import * as $ from 'jquery';
import { AppModule } from '../../lib/app-module';
import { getQueryValue } from '../../lib/query';


export interface ModalConfig {
    modalId: string;
    modalContentId: string;
    modalCloseId: string
}

interface OpenModalOptions {
    templateId: string;
    clickOutsideCloses?: boolean; // default false
}

interface OpenOnQueryOptions {
    key: string;
    value: string;
    modal: OpenModalOptions
    keepQuery?: boolean; // default false
}

interface ModalExport {
    open: (options: OpenModalOptions) => void;
    openOnQuery: (options: OpenOnQueryOptions) => void;
    close: () => void;
}

export class Modal extends AppModule<ModalConfig, ModalExport> {
    private modal: HTMLElement;
    private modalContent: HTMLElement;

    protected init(): void {
        this.initModal();
        this._export = {
            open: (options) => this.openModal(options),
            close: () => this.closeModal(),
            openOnQuery: (options) => this.openOnQuery(options)
        };
    }

    private initModal(): void {
        this.modal = document.getElementById(this.config.modalId) as HTMLElement;
        this.modalContent = document.getElementById(this.config.modalContentId) as HTMLElement;
        const close = document.getElementById(this.config.modalCloseId) as HTMLElement;
        close.onclick = (): void => this.closeModal();
    }

    private openModal({templateId, clickOutsideCloses}: OpenModalOptions): void {
        this.showModal();
        const template = document.getElementById(templateId) as HTMLElement;
        const templateClone = document.importNode(template, true);
        $(this.modalContent).html(templateClone.innerHTML);
        this.handleClickOutside(clickOutsideCloses);
    }

    private openOnQuery(options: OpenOnQueryOptions): void {
        if (getQueryValue(options.key) === options.value){
            $(() => { this.openModal(options.modal); });
            if (!options.keepQuery) {
                const locationWithoutQuery = window.location.pathname + window.location.hash;
                window.history.replaceState(null, document.title, locationWithoutQuery);
            }
        }
    }

    private handleClickOutside(clickOutsideCloses: boolean | undefined): void {
        if (clickOutsideCloses ?? false) {
            this.modal.onclick = (event): void => {
                if (event.target === this.modal) {
                    this.closeModal();
                }
            };
        } else {
            this.modal.onclick = (): void => {return;};
        }
    }

    private showModal(): void {
        this.modal.style.display = 'block';
    }

    private closeModal(): void {
        this.modal.style.display = 'none';
        this.modalContent.innerHTML = '';
    }
}